<template>
    <div class="ma-2">
        <v-row no-gutters class="mb-2">
            <v-btn small link class="ma-2" @click="exportXLS()">{{ $t("page.events.registration.xls") }}</v-btn>
            <v-btn small link class="ma-2" @click="exportCVS()">{{ $t("page.events.registration.cvs") }}</v-btn>
            <v-btn small link class="ma-2" @click="exportPDF()">{{ $t("page.events.registration.pdf") }}</v-btn>
        </v-row>
        <v-row no-gutters class="container-responsive-for-table">
                <VueTabulator
                    ref="tabulator"
                    v-model="list"
                    :options="tabulatorOptions"
                />
        </v-row>
    </div>
</template>

<script>

export default {
  props: ["list"],
  computed: {
    tabulatorOptions: function () {
        return {
            placeholder: this.$t("page.events.tabulator.noRegistrantsYet"),
            height: '600px',
            printAsHtml: true,
            layout: "fitDataFill",
            responsiveLayout: false,
            initialSort: [
                { column: "firstName", dir: "asc", }
            ],
            columns: [
                {
                    title: this.$t("page.events.tabulator.first-name"),
                    field: "firstName",
                    sorter: "string",
                    width: 200,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.last-name"),
                    field: "lastName",
                    sorter: "string",
                    width: 200,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.phone-number"),
                    field: "phone",
                    sorter: "string",
                    width: 150,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.date-birth"),
                    field: "dateBirth",
                    sorter: "string",
                    width: 150,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.registered-by"),
                    field: "registeredBy",
                    sorter: "string",
                    width: 150,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.status"),
                    field: "status",
                    sorter: "string",
                    width: 150,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.created_date"),
                    field: "created_at",
                    sorter: "string",
                    width: 150,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                }
            ]
        };
    },
  },
  methods: {
      exportXLS() {
          const tabulatorInstance = this.$refs.tabulator.getInstance();
          tabulatorInstance.downloadToTab("xlsx", "data.xlsx");
      },
      exportCVS() {
          const tabulatorInstance = this.$refs.tabulator.getInstance();
          tabulatorInstance.downloadToTab("csv", "data.csv");
      },
      exportPDF() {
          const tabulatorInstance = this.$refs.tabulator.getInstance();
          tabulatorInstance.downloadToTab("pdf", "pdf.csv");
      }
  }
};
</script>

<style scss>
.color-check {
    color: var(--v-success-base);
}
.color-failed {
    color: var(--v-error-base);
}
.container-responsive-for-table {
    max-width: 100% !important;
    overflow-x: auto;
}
</style>
